import { sendOpenMobileListMenuEvent } from '../../menus/list-menu/services/list-menu-provider';
import { Filter } from './filter/filter';
import { SortDropDown } from './sort/sort-drop-down';
import { ThemeButtons } from './theme-buttons/theme-buttons';
import { ProductsIOwn } from './products-i-own/products-i-own';
import { IPanelProps } from '../interfaces/interfaces';
import { LIST_TO_GRID_ENDPOINT } from '../services/list-page-provider';

/**
 * jPList top panel.
 */
export const TopPanel = (props: IPanelProps) => {


    return (
        <div className="md:border-b mb-10 pb-2 flex flex-col md:flex-row items-center w-full">

            <div className="mb-4 md:mb-0">
                <ProductsIOwn />
            </div>

            <div className="flex items-center flex-1">

                {/* mobile manu button */}
                <button
                    type="button"
                    className="flex items-center text-tiny font-normal text-gray-450 border md:border-0 rounded px-6 py-1 mr-4 lg:hidden h-10 md:h-auto"
                    onClick={ () => { sendOpenMobileListMenuEvent(); } }>
                    <svg width="30" height="30" viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg"><g fill="none" fillRule="evenodd"><path d="M0 0h30v30H0z"/><path d="M16.438 18.333c.517 0 .937.373.937.834 0 .46-.42.833-.938.833h-1.875c-.517 0-.937-.373-.937-.833 0-.46.42-.834.938-.834h1.874zm2.812-4.166c.518 0 .938.373.938.833 0 .46-.42.833-.938.833h-7.5c-.518 0-.938-.373-.938-.833 0-.46.42-.833.938-.833h7.5zM22.063 10c.517 0 .937.373.937.833 0 .46-.42.834-.938.834H8.938c-.517 0-.937-.373-.937-.834 0-.46.42-.833.938-.833h13.124z" fill="#4A4A4A"/></g></svg>
                    <span>Filter</span>
                </button>

                {
                    (!props.width || props.width > LIST_TO_GRID_ENDPOINT) &&
                    <div className="mx-4 hidden md:block">
                        <ThemeButtons />
                    </div>
                }

                <div className="ml-auto md:mr-4">
                    <SortDropDown />
                </div>

                <div className="mx-4 md:mr-0 hidden md:block">
                    <Filter />
                </div>
            </div>
        </div>

    )
};